/**
 * ws 配置
 */
export interface IWsOption {
    /** ws token */
    token: string;
    /** ws 地址 */
    host: string;
    /** 会话组id，可以用作图记录id */
    group?: string | number;
    /** uid */
    uid?: string | number;
    /** 心跳包时间 */
    heartbeat?: number;
    /** debug 模式 */
    is_debug?: boolean;
}

/**
 * 消息类型
 */
export enum WsType {
    /** 建立链接 */
    Connect = 1,
    /** 心跳包 */
    Heartbeat = 2,
    /** 在线成员变更 */
    MembersChange = 3,
    /** 主动断开 */
    Close = 9,
    /** 编辑操作，服务端只做转发 */
    Edit = 100,
}

/**
 * 消息格式
 */
export interface IWsMsg {
    /** 消息类型 */
    type: WsType;
    /** 业务内容 */
    content?: string;
    /** 额外内容 */
    ext?: string;
    /** 会话组id */
    group?: number | string;
    /**  wsid，通过 WsType.Connect 事件下发  */
    ws_member_key: string;
    /** 消息来源uid */
    from_uid?: number;
    /** 消息来源wsid */
    from_ws_member_key?: string;
}
